import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { API } from '../../services/api';
const api = new API();

// Singe feed view state

export const fetchFeed = createAsyncThunk(
  'feed/get',
  async (data, thunkAPI) => {
    try {
      const { ownerId, feedId } = data;
      const response = await api.getFeedInfo(ownerId, feedId);

      if(response.status === 'ok') {
        return response.result;
      } else {
        return thunkAPI.rejectWithValue(response);
      }
    } catch(e) {
      // System error or status code >= 500
      console.error('ERROR: feed/get', e.message);
      return thunkAPI.rejectWithValue('INTERNAL_SERVER_ERROR');
    }
  }
);

export const saveFeed = createAsyncThunk(
  'feed/save',
  async (data, thunkAPI) => {
    try {
      const { ownerId, feedId, order } = data;

      // We just need the code.
      const trimmed = order.map(product => ({code: product.code}));
      const response = await api.saveFeedOrder(ownerId, feedId, {order: trimmed});

      if(response.status === 'ok') {
        return response.result;
      } else {
        return thunkAPI.rejectWithValue(response);
      }
    } catch(e) {
      // System error or status code >= 500
      console.error('ERROR: feed/save', e.message);
      return thunkAPI.rejectWithValue('INTERNAL_SERVER_ERROR');
    }
  }
);

const initialState = {
  feed: {},
  fetchStatus: 'idle',
  fetchError: null,
  saveStatus: 'idle',
  saveError: null
};

export const feedSlice = createSlice({
  name: 'feed',
  initialState,
  reducers: {
    clearSaveStatus: (state, action) => {
      state.saveStatus = 'idle';
    }
  },
  extraReducers: {
    // Add reducers for additional action types here, and handle loading state as needed
    [fetchFeed.fulfilled]: (state, action) => {
      state.fetchStatus = 'succeeded';
      state.fetchError = null;
      state.feed = {
        ...action.payload.feed,
        items: (action.payload.feedItems || []).map(item => ({code: item.code, name: item.name, image: item.imageMain?.thumbnail})),
        readers: action.payload.feedTokens || [],
      };
    },
    [fetchFeed.pending]: (state, action) => {
      state.feed = {};
      state.fetchStatus = 'loading';
      state.fetchError = null;
    },
    [fetchFeed.rejected]: (state, action) => {
      let message = 'INTERNAL_SERVER_ERROR';

      if(typeof action.payload === 'string') {
        // error message
        message = action.payload;
      } else if(action.payload.messages.length) {
        message = action.payload.messages.join(', ');
      }

      state.feed = {};
      state.fetchStatus = 'failed';
      state.fetchError = message;
    },

    [saveFeed.fulfilled]: (state, action) => {
      state.saveStatus = 'succeeded';
      state.saveError = null;
    },
    [saveFeed.pending]: (state, action) => {
      state.saveStatus = 'loading';
      state.saveError = null;
    },
    [saveFeed.rejected]: (state, action) => {
      let message = 'INTERNAL_SERVER_ERROR';

      if(typeof action.payload === 'string') {
        // error message
        message = action.payload;
      } else if(action.payload.messages.length) {
        message = action.payload.messages.join(', ');
      }

      if(action.payload?.result?.errors?.user) {
        message += ', ' + action.payload.result.errors.user.join(', ');
      }

      state.saveStatus = 'failed';
      state.saveError = {
        message: message
      };
    },
  }
});

export const { clearSaveStatus } = feedSlice.actions;

export const selectFeed = state => state.feed;

export const selectFetchStatus = state => ({
  fetchStatus: state.feed.fetchStatus,
  fetchError: state.feed.fetchError,
  feed: state.feed.feed
});

export default feedSlice.reducer;
